<mat-toolbar class="border-b border-gray-200 shrink-0 relative">
  <ng-content></ng-content>
  <div class="ml-auto flex items-center gap-2">
    <span
      class="inline-flex items-center px-3 py-1 text-sm font-medium text-slate-700 bg-slate-100 border border-slate-200 rounded-full"
    >
      {{ currentUser?.displayName ?? 'Gebruikersnaam' }}
    </span>
    <button mat-icon-button matTooltip="Uitloggen" (click)="logout()">
      <mat-icon>logout</mat-icon>
    </button>
  </div>

  @if (globalLoaders.isActive(loaderId)) {
    <div class="absolute bottom-0 left-0 w-[100%]">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
</mat-toolbar>
